"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var moment = require("moment");
var utils_1 = require("@vidazoo/ui/lib/components/utils");
var enums_1 = require("../common/enums");
var ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function guid(len) {
    if (len === void 0) { len = 8; }
    var g = "";
    for (var i = 0; i < len; i++) {
        g += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
    }
    return g;
}
exports.guid = guid;
function normalizeEventValue(e) {
    switch (e.target.type.toLowerCase()) {
        case "checkbox":
        case "radio":
            return e.target.checked;
        case "number": {
            var value = parseFloat(e.target.value);
            return !_.isNaN(value) ? value : "";
        }
        default:
            return e.target.value;
    }
}
exports.normalizeEventValue = normalizeEventValue;
function formatNumber(num, fixed) {
    var value = (num || 0).toString();
    var options = {};
    if (!isNaN(fixed)) {
        options.maximumFractionDigits = fixed;
    }
    return parseFloat(value).toLocaleString(undefined, options);
}
exports.formatNumber = formatNumber;
function percentageOf(value, total) {
    return value / total * 100;
}
exports.percentageOf = percentageOf;
function momentToTimeZoneUnix(date, timezone) {
    return date.unix() + moment.tz.zone(timezone).utcOffset(date) * 60;
}
exports.momentToTimeZoneUnix = momentToTimeZoneUnix;
function fastClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}
exports.fastClone = fastClone;
function noop() {
    //
}
exports.noop = noop;
function getCurrentHour() {
    return moment().utc().hour();
}
exports.getCurrentHour = getCurrentHour;
function getCurrentWeek() {
    return moment().utc().diff(moment.utc().startOf("isoWeek"), "hours");
}
exports.getCurrentWeek = getCurrentWeek;
function getLastWeek() {
    return moment().utc().diff(moment.utc().subtract(1, "week").startOf("isoWeek"), "hours");
}
exports.getLastWeek = getLastWeek;
function getCurrentMonth() {
    return moment().utc().diff(moment.utc().startOf("month"), "hours");
}
exports.getCurrentMonth = getCurrentMonth;
function getLastMonth() {
    return moment().utc().diff(moment.utc().subtract(1, "month").startOf("month"), "hours");
}
exports.getLastMonth = getLastMonth;
function getPastDays(days) {
    return moment().utc().diff(moment.utc().subtract(days, "day").startOf("day"), "hours");
}
exports.getPastDays = getPastDays;
function digest(value) {
    return {
        digest: function (fn) {
            var digestedValue = fn(value);
            return typeof digestedValue !== "undefined"
                ? digest(digestedValue)
                : digest(value);
        },
        done: function () {
            return value;
        }
    };
}
exports.digest = digest;
function isRegExpStr(predicate) {
    return predicate && predicate.indexOf("/") === 0 && predicate.lastIndexOf("/") === predicate.length - 1;
}
exports.isRegExpStr = isRegExpStr;
function filterReportingResults(results, searchQueries) {
    var hasQueries = _.compact(_.values(searchQueries)).length;
    if (hasQueries) {
        return _.filter(results, function (item) {
            var queryResults = [];
            _.forEach(item.groups, function (group) {
                var groupQuery = _.find(searchQueries, function (query, groupName) {
                    return group.name === groupName;
                });
                if (groupQuery) {
                    var value = group.value ? group.value.toString() : "";
                    var isValueMatchToRegExp = false;
                    if (isRegExpStr(groupQuery)) {
                        isValueMatchToRegExp = !!value.match(new RegExp(_.trim(groupQuery, "/"), "ig"));
                    }
                    queryResults.push(utils_1.multiWordFilter(value, groupQuery) || isValueMatchToRegExp);
                }
            });
            return _.every(queryResults);
        });
    }
    return results;
}
exports.filterReportingResults = filterReportingResults;
function tryParseJSON(json) {
    try {
        return JSON.parse(json);
    }
    catch (e) {
        return null;
    }
}
exports.tryParseJSON = tryParseJSON;
function tryStringifyJSON(json, replacer, space) {
    try {
        return JSON.stringify(json, replacer, space);
    }
    catch (e) {
        return "";
    }
}
exports.tryStringifyJSON = tryStringifyJSON;
function getTimezoneNameAsUtcOffset(timezone, unixTimestamp) {
    if (!timezone || timezone.startsWith("Etc")) {
        return timezone;
    }
    // moment returns the offset in minutes, divide by 60 to get hours
    var offsetHours = moment.tz.zone(timezone).utcOffset(unixTimestamp * 1000) / 60;
    var positiveSign = offsetHours > -1 ? "+" : "";
    return "Etc/GMT" + (positiveSign + offsetHours);
}
exports.getTimezoneNameAsUtcOffset = getTimezoneNameAsUtcOffset;
function extractReportingFieldValue(data, key, reportType) {
    if (key === void 0) { key = "value"; }
    if (reportType === void 0) { reportType = enums_1.ReportFieldValueType.ORIGINAL; }
    if (data[key] instanceof Array) {
        var _a = data[key], originalValue = _a[0], compareValue = _a[1], delta = _a[2], diff = _a[3];
        switch (reportType) {
            case enums_1.ReportFieldValueType.ORIGINAL:
                return originalValue;
            case enums_1.ReportFieldValueType.COMPARE:
                return compareValue;
            case enums_1.ReportFieldValueType.DELTA:
                return delta;
            case enums_1.ReportFieldValueType.DELTA_PCT:
                return diff;
        }
    }
    return data[key];
}
exports.extractReportingFieldValue = extractReportingFieldValue;
function refreshAllCodeMirrorEditors() {
    utils_1.nodeListToArrayOf(document.querySelectorAll(".CodeMirror")).map(function (element) {
        if (element.CodeMirror) {
            element.CodeMirror.refresh();
        }
    });
}
exports.refreshAllCodeMirrorEditors = refreshAllCodeMirrorEditors;
function getAutoCompleteListWidth() {
    var innerWidth = window.innerWidth;
    if (innerWidth < 1050) {
        return 300;
    }
    else if (innerWidth < 1200) {
        return 500;
    }
    else if (innerWidth < 1550) {
        return 700;
    }
    else {
        return 1000;
    }
}
exports.getAutoCompleteListWidth = getAutoCompleteListWidth;
